module.exports = __webpack_public_path__ + "static/media/trash3.ce840ef5.svg";